import './window'
import { computed, type App, type Plugin } from 'vue';
import { createPinia } from 'pinia';
export { defineStore, disposePinia, createPinia } from 'pinia';
export { createRouter, createWebHistory, useLink, useRoute, useRouter, type RouteRecordRaw } from 'vue-router';
import { createLocale } from './scripts/translate';
import { useAuthStore, useGeneralStore } from './global';
import filters from './filters';
export { useAuthStore } from './stores/auth';
export { useGeneralStore } from './stores/general';
import Modal from './components/modal/Modal.vue';
import NoData from './components/NoData.vue';
import Loader from './components/Loader.vue';
import CoreLoader from './components/CoreLoader.vue';
import FilePreview from './components/FilePreview.vue';

export interface Variables {
    input?: any
    inputData?: any
    where?: any
    accessRole?: any
    route?: any
    orderBy?: any
    limit?: any
    page?: any,
    download?: { type?: string, query?: any },
}

// 1. Define an interface for your plugin options
interface PluginOptions {
  greeting?: string;
  debug?: boolean;
}

export const LoadGeneral: Plugin = {
    install(app: App, options: PluginOptions = {}) {
        app.use(createLocale({}))
        app.use(createPinia())

        app.component('modal', Modal)
        app.component('no-data', NoData)
        app.component('preview-file', FilePreview)
        app.component('file-preview', FilePreview)
        app.component('loader', Loader)
        app.component('core-loader', CoreLoader)

        // Restore session on app load
        useAuthStore().restoreSession()
        useGeneralStore().restoreSession()

        // Set global properties
        app.config.globalProperties.$baseUrl = window.location.origin;
        app.config.globalProperties.$currentHost = window.location.host;
        app.config.globalProperties.$prefixUrl = window.$prefixUrl;
        app.config.globalProperties.$moduleName = window.$moduleName;
        app.config.globalProperties.$isDesktop = false;
        app.config.globalProperties.$filter = filters;
        app.config.globalProperties.$isPermitted = window.$isPermitted;
        app.config.globalProperties.$isMobile = computed(() => {
            return window.innerWidth <= 768; // Example breakpoint for mobile devices
        });
    }
};